var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { useTranslation } from 'react-i18next';
import { Container } from './subcomponents';
var CERTIFICATE_STATUS_LABELS = {
    USED: 'certificateHistoryTab.redeemed',
    EXPIRED: 'certificateHistoryTab.expired'
};
var CertificateStatusTag = function (_a) {
    var certificateStatus = _a.certificateStatus;
    var t = useTranslation().t;
    var status = certificateStatus;
    return (
    // eslint-disable-next-line react/jsx-no-useless-fragment
    _jsx(_Fragment, { children: certificateStatus === 'EXPIRED' || certificateStatus === 'USED' ? (_jsx(Container, __assign({ "$statusType": status }, { children: t(CERTIFICATE_STATUS_LABELS[status]) }))) : null }));
};
export default CertificateStatusTag;
